import React from "react";
import { Bar, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import styled from "styled-components";
import { C4Text } from "../text/CustomText";
import { Theme } from "../../Theme";

// 1. 데이터 샘플
const data = [
    { name: "08-03", total: 70, remain: 18 },
    { name: "08-04", total: 60, remain: 38 },
    { name: "08-05", total: 70, remain: 12 },
    { name: "08-06", total: 64, remain: 28 },
    { name: "08-07", total: 82, remain: 45 },
    { name: "08-08", total: 25, remain: 25 },
    { name: "08-09", total: 86, remain: 33 },
];

// 2. 커스텀 툴팁 스타일링
const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <TooltipContainer>
                <p className="label">{label}</p>
                <TooltipItem color={Theme.color.indigo600}>
                    <span className="title">Total</span>
                    <span className="value">{payload[0].value}%</span>
                </TooltipItem>
                <TooltipItem color={Theme.color.rose400}>
                    <span className="title">Remain</span>
                    <span className="value">{payload[1].value}%</span>
                </TooltipItem>
            </TooltipContainer>
        );
    }
    return null;
};

function parseEntryName(name) {
    if (name === "total") {
        return "Total Tickets";
    } else if (name === "remain") {
        return "Remain Tickets";
    } else {
        return name;
    }
}

const CustomPeakChartLegend = (props) => {
    const { payload } = props;

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                gap: "15px",
                paddingTop: "25px",
            }}
        >
            {payload.map((entry, index) => (
                <div key={`item-${index}`} style={{ display: "flex", alignItems: "center" }}>
                    {/* 동그란 아이콘 */}
                    {entry.value === "total" && (
                        <div
                            style={{
                                width: "8px",
                                height: "8px",
                                backgroundColor: entry.color, // 👈 데이터 색상
                                borderRadius: "100%",
                                marginRight: "6px",
                            }}
                        />
                    )}
                    {/* 직선 아이콘 */}
                    {entry.value === "remain" && (
                        <div
                            style={{
                                width: "10px",
                                height: "2px",
                                backgroundColor: entry.color, // 👈 데이터 색상
                                borderRadius: "4px",
                                marginRight: "6px",
                            }}
                        />
                    )}
                    {/* 2. 텍스트 */}
                    <C4Text fontColor={Theme.color.gray500}>{parseEntryName(entry.value)}</C4Text>
                </div>
            ))}
        </div>
    );
};

const TicketChart = () => {
    return (
        <div style={{ width: "100%", height: 460, backgroundColor: "transparent" }}>
            <ResponsiveContainer width="100%" height="100%">
                <ComposedChart data={data} margin={{ top: 20, right: 20, bottom: 20, left: 0 }}>
                    <CartesianGrid stroke={Theme.color.gray150} vertical={false} />
                    <XAxis
                        dataKey="name"
                        axisLine={false}
                        tickLine={false}
                        tick={{ fill: Theme.color.gray400, fontSize: 12 }}
                        dy={6}
                    />
                    <YAxis axisLine={false} tickLine={false} tick={{ fill: Theme.color.gray400 }} domain={[0, 100]} />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend content={<CustomPeakChartLegend />} />

                    {/* 막대 그래프 (Peak) - 상단 둥글게 처리 */}
                    <Bar
                        dataKey="total"
                        barSize={12}
                        fill={Theme.color.indigo500}
                        radius={[10, 10, 0, 0]} // [top-left, top-right, bottom-right, bottom-left]
                        label={{
                            position: "top",
                            fill: Theme.color.zinc850,
                            fontSize: 12,
                            formatter: (val) => `${val}%`,
                        }}
                        animationDuration={0}
                    />
                    {/* 라인 그래프 (Average) */}
                    <Line
                        dataKey="remain"
                        stroke={Theme.color.orange500}
                        strokeWidth={2}
                        dot={{ r: 2, fill: Theme.color.orange500 }}
                        animationDuration={0}
                    />
                </ComposedChart>
            </ResponsiveContainer>
        </div>
    );
};

export default TicketChart;

// --- Styled Components ---

const TooltipContainer = styled.div`
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 20px ${Theme.color.black_01};
    padding: 15px;
    border: none;
    .label {
        margin: 0 0 10px 0;
        font-weight: bold;
        color: ${Theme.color.gray800};
    }
`;

const TooltipItem = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 5px;
    &::before {
        content: "";
        width: 3px;
        height: 30px;
        background-color: ${(props) => props.color};
        border-radius: 2px;
    }
    .title {
        color: ${Theme.color.neutral400};
        flex: 1;
        font-size: 14px;
    }
    .value {
        font-weight: bold;
        font-size: 16px;
        color: ${Theme.color.gray800};
    }
`;
